import Uri from 'uri-templates';
import TagManager from 'react-gtm-module';
import {dataGetter} from "./ApiService";
import { updateGateStatistics } from './PostService';
import { getReferrer, getSourceId } from './CacheService';
import {setPositionStyles} from "./Style";


function setCustomerProperties(customerData) {
	document.title = customerData.result.name;
	if (customerData.result.gateSettings
		&& customerData.result.gateSettings.gtmId !== undefined
		&& customerData.result.gateSettings.gtmId !== null
		&& customerData.result.gateSettings.gtmId.length > 0) {
		TagManager.initialize({ gtmId: customerData.result.gateSettings.gtmId });
	}
}

export default async function getCustomerData(customerName) {
	const customerData = JSON.parse(sessionStorage.getItem(`customerData-${customerName}`));
	if (customerData) {
		setCustomerProperties(customerData);
		return Promise.resolve(customerData);
	}

	const uri = Uri('/api/v2/customer/{customerName}/info{?sourceId,referrer}')
		.fill({
			customerName,
			sourceId: getSourceId(),
			referrer: getReferrer(),
		});

	return dataGetter(uri)
		.then(response => response.json())
		.then((json) => {
			sessionStorage.setItem(`customerData-${customerName}`, JSON.stringify(json));
			setCustomerProperties(json);
			return json;
		})
		.catch(reason => setTimeout(function() { return  getCustomerData(customerName);}, 1000));
}

export function getAgencyData(hash) {
    let agency = JSON.parse(sessionStorage.getItem('agency-' + hash));
    if (agency) {
        return Promise.resolve(agency);
    }
    return dataGetter('/api/v2/agency/' + hash)
        .then( response => response.json() )
        .then((data) => {
            sessionStorage.setItem('agency-' + hash, JSON.stringify(data));
            return data;
    });
}

export function getAgencyPositionList(hash) {
    return dataGetter('/api/v2/agency/' + hash + '/positions')
        .then(response => response.json());
}

export function getAgencyPosition(hash, positionId) {
    return dataGetter('/api/v2/agency/' + hash + '/position/' + positionId)
        .then(response => response.json());
}

export async function getPositionList(customerName) {
    return dataGetter( '/api/v2/gate/'+ customerName +'/positions')
        .then(response => response.json())
        .catch(reason => {
        return setTimeout(function() { return getPositionList(customerName) }, 1000);
    })
}

export function getPosition(positionId, customerName) {
    if (!isFinite(String(positionId).trim() || NaN)|| !customerName) {
        return null;
    }
    return dataGetter( '/api/v2/gate/'+customerName+'/positions/'+ positionId)
        .then( response => response.json())
        .then((json) => {
            if (json.success) {
				setPositionStyles(positionId, json.result.styles);

                let visited = localStorage.getItem('visited');
                try {
                    visited = JSON.parse(visited) || [];
                    visited = Array.isArray(visited) ? visited : [visited];
                } catch (e) {
                    visited = visited.split(',').map(x=>+x);
                }

				let noView = false;
				const url = new URL(window.location.href);
				if (url.searchParams.has('noView')) {
					noView = true;
					url.searchParams.delete('noView');
					window.history.replaceState(null, '', url.toString());
				}


				if (visited.indexOf(positionId) === -1 && !noView) {
                    visited.push(positionId);
                    localStorage.setItem('visited', JSON.stringify(visited));
                    let actualDate = new Date();
                    updateGateStatistics({
                        'customerName': customerName,
                        'positionId': positionId,
                        'type': 'open',
                        'date': actualDate.getFullYear()+'-'+(actualDate.getMonth()+1)+'-'+actualDate.getDate()
                    });
                }
            }
            return json;
        });
}

export function getTranslationDict() {
    return dataGetter( '/api/v2/gate/messages');
}

export function getGlobalGateForm(customerName){
    return dataGetter('/api/v2/gate/'+customerName+'/form')
}

export function getPublicationCategories(customerName, language){
	return dataGetter('/api/v2/gate/'+ customerName +'/publication-categories', language)
}

export async function getCustomerStyles(customerName) {
    return await dataGetter('/api/v2/gate/'+customerName+'/styles');
}

export function getGateCheckboxes(customerName) {
    return dataGetter('/api/v2/gate/'+customerName+'/checkboxes')
}

export function getAgencyCheckboxes(hash) {
    return dataGetter('/api/v2/agency/'+hash+'/checkboxes')
}

export function getPositionTypeOptions(customerName, language) {
    return dataGetter('/api/v2/gate/'+customerName+'/position-types', language);
}

export function getBusinessUnitOptions(customerName, language) {
    return dataGetter('/api/v2/gate/'+customerName+'/business-units', language);
}
